import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { capitalizeFirstLetter, convertTo12HourFormat } from "../data/Utils";
import CustomDropdownMenu from "../mui/dropdown";


export default function UserOrders({ user,  onItemsSelection }) {
  return (
    <div

      style={{ display: "flex", flexDirection: "column" }}
    >
      {/* <div className="bg-white w-40 rounded-md">
        <CustomDropdownMenu
          width={140}
          list={["Defualt", "This Week", "This Month", "This Year"]}
        />
      </div> */}

      <TableContainer
        component={Paper}
        sx={{ marginTop: "16px", marginInlineStart: 1 }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight:'600'}}>ID</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">KITCHEN ID</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">DATE</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">TIME</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">TOTAL AMOUNT</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">BILL ID</TableCell>

              <TableCell style={{fontWeight:'600'}} align="left">PAYMENT</TableCell>
              <TableCell style={{fontWeight:'600'}} align="left">STATUS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {user.orders?.map((row) => (
              <TableRow
                onClick={() => onItemsSelection(row.items)}
                className="cursor-pointer hover:bg-yellow-200"
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  style={{
                    fontSize: "19px",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontSize: "17px" }}
                >
                  {row.kitchen_id}
                </TableCell>
              
                <TableCell align="left" style={{ fontSize: "17px" }}>
                  {row.created_at.split("T")[0]}
                </TableCell>
                <TableCell align="left" style={{ fontSize: "17px" }}>
                  {convertTo12HourFormat(
                    row.created_at.split("T")[1].split(".")[0]
                  )}
                </TableCell>
                <TableCell align="left" style={{ fontSize: "17px" }}>
                  {row.total_amount/100}
                  <p
                    className="inline"
                    style={{
                      color: "green",
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                  >
                    {" "}
                    RM
                  </p>
                </TableCell>
                <TableCell align="left" style={{ fontSize: "17px" }}>
                  {row.bill_id}
               
                </TableCell>
                <TableCell component="th" scope="row">
                  <span
                    style={{ fontWeight: "600" }}
                    className={`${
                      row.is_paid == "true" ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {row.is_paid == "true" ? "Paid" : "Not Paid"}
                  </span>
                </TableCell>
                <TableCell component="th" scope="row">
                  <span
                    style={{ fontWeight: "600" }}
                    className={`"text-green-600" ${
                      row.status == "successful"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {capitalizeFirstLetter(row.status)}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
